import { Action, combineReducers } from 'redux';
import { ThunkDispatch as ReduxThunkDispatch, ThunkAction } from 'redux-thunk';

import accounts from './accounts';
import api from './api';
import auth from './auth';
import authmethods from './authmethods';
import bindings from './bindings';
import challenge from './challenge';
import config from './config';
import counter from './counter';
import intl from './intl';
import payees from './payees';
import tracelog from './tracelog';

const rootReducer = combineReducers({
  accounts,
  api,
  auth,
  authmethods,
  bindings,
  challenge,
  config,
  counter,
  tracelog,
  intl,
  payees,
})


export default rootReducer

export type IStoreState = ReturnType<typeof rootReducer>
export type ThunkResult<R> = ThunkAction<R, IStoreState, null, Action>
export type ThunkDispatch = ReduxThunkDispatch<IStoreState, null, Action>
